/**
 * Utilidades para teléfonos españoles.
 *
 * Regla principal: para Avizor y videoperitaciones SIEMPRE preferimos el
 * móvil (los proveedores envían SMS, no funcionan con fijo). En España un
 * móvil empieza por 6 o 7 una vez normalizado a 9 dígitos.
 */

/** Quita prefijo, espacios y caracteres no numéricos y devuelve los
 * últimos 9 dígitos (formato nacional español). */
export function normalizeESPhone(v) {
  if (!v) return "";
  const digits = String(v).replace(/\D/g, "");
  return digits.slice(-9);
}

/** ¿Parece un móvil español (9 dígitos empezando por 6 o 7)? */
export function isMobileES(v) {
  return /^[67]\d{8}$/.test(normalizeESPhone(v));
}

/**
 * Devuelve el primer candidato que parezca móvil español; si ninguno lo
 * parece, devuelve el primer valor no vacío (mantenemos compatibilidad
 * con datos antiguos o números internacionales).
 */
export function pickMobileFirst(...candidates) {
  const cleaned = candidates
    .map((c) => (c == null ? "" : String(c).trim()))
    .filter(Boolean);
  return cleaned.find(isMobileES) || cleaned[0] || "";
}
